module.exports = "/images/area_verde.svg?8a877fbf5da2b18c5efada615659c61d";